import { createFileRoute } from "@tanstack/react-router";
import CompanyInfoForm from "@/components/company/form-company-info";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

export const Route = createFileRoute("/_authenticated/settings/_layout/")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "companies", actions: ["read", "update"] }]}
    >
      <CompanyInfoForm />
    </RouteGuardPermissions>
  );
}
